import { getOrgaFooterContents } from "@sia/shared/js/contents/layout";

export function useFooterContents(language) {
  return getOrgaFooterContents({
    links: {
      privacyPolicy: {
        target: process.env.REACT_APP_SIA_WEBSITE_URL ? `${process.env.REACT_APP_SIA_WEBSITE_URL}/${language}/cms/node/54` : "privacy-policy",
      },
      newsletter: {
        target: process.env.REACT_APP_CMS_URL ? `/${language}/cms/newsletter` : undefined,
      },
    },
    contactUs: {
      target: process.env.REACT_APP_CMS_URL ? `/${language}/cms/beratung` : undefined,
    },
  });
}
